import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import moment from "moment";
import I18n from "i18n-js";

import DateInput from "../../../commons/DateInput";
import TimeInput from "../../../commons/TimeInput";
import SelectInput from "../../../commons/SelectInput";
import RadioGroup from "../../../commons/RadioGroup";

import Input from "../Input";
import ChipGroup from "../ChipGroup";
import FormSection from "./FormSection";

const TimeWithVicky = ({ hourStyle }) => {

  const { control, watch, setValue, defaultValues, formState: { errors } } = useFormContext();

  const error = errors.time
    || errors.frequency
    || errors.periodicity
    || errors.repeat
    || errors.ending?.type
    || errors.ending?.on
    || errors.ending?.after;

  const today = moment().format("YYYY-MM-DD");

  const renderEndDateOption = () => (
    <Controller
      name="ending.on"
      control={control}
      render={({ field: { ref, ...props } }) => (
        <DateInput
          slim
          className="pdp-radio-button-date"
          min={today}
          placeholder={I18n.t("pdp.form.time_with_vicky.fields.ending.options._on.end_date")}
          error={errors?.ending?.on?.message}
          disabled={watch("ending.type") !== "on"}
          inputRef={ref}
          {...props}
        />
      )}
    />
  );

  const renderEndOccurencesOption = () => (
    <div className="pdp-radio-button-occurrences">
      <Controller
        name="ending.after"
        control={control}
        render={({ field: { ref, ...props } }) => (
          <Input
            slim
            type="number"
            min="1"
            error={errors?.ending?.after?.message}
            disabled={watch("ending.type") !== "after"}
            inputRef={ref}
            {...props}
          />
        )}
      />
      {I18n.t("pdp.form.time_with_vicky.fields.ending.options.after.occurrences")}
    </div>
  );

  return (
    <FormSection
      title={I18n.t("pdp.form.time_with_vicky.title")}
      description={I18n.t("pdp.form.time_with_vicky.description")}
    >
      <div className="pdp-form-item">
        <div className="pdp-form-row">
          {I18n.t("pdp.form.time_with_vicky.fields.time.label")}
          <TimeInput
            slim
            twelveHour={hourStyle === "twelve"}
            className="pdp-input-meet-time"
            initialValue={defaultValues.time}
            error={errors.time}
            onValueSelected={value => setValue("time", value)}
          />
          {I18n.t("pdp.form.time_with_vicky.fields.frequency.label")}
          <SelectInput
            slim
            className="pdp-select-meet-frequency"
            options={[...Array(12).keys()].map(key => ({
              label: `${key + 1}`,
              value: `${key + 1}`
            }))}
            initialValue={defaultValues.frequency}
            error={errors.frequency}
            onValueSelected={value => setValue("frequency", value)}
          />
          <SelectInput
            slim
            className="pdp-select-meet-periodicity"
            options={[
              { label: I18n.t("pdp.form.time_with_vicky.fields.periodicity.options.week"), value: "week" },
              { label: I18n.t("pdp.form.time_with_vicky.fields.periodicity.options.month"), value: "month" },
            ]}
            initialValue={defaultValues.periodicity}
            error={errors.periodicity}
            onValueSelected={value => setValue("periodicity", value)}
          />
        </div>
      </div>
      <div className="pdp-form-item">
        <span className="pdp-form-item-title">{I18n.t("pdp.form.time_with_vicky.fields.repeat.label")}</span>
        <ChipGroup
          multiSelect
          options={[
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.repeat.options.monday"),
              value: "monday"
            },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.repeat.options.tuesday"),
              value: "tuesday"
            },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.repeat.options.wednesday"),
              value: "wednesday"
            },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.repeat.options.thursday"),
              value: "thursday"
            },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.repeat.options.friday"),
              value: "friday"
            }
          ]}
          value={watch("repeat")}
          error={errors.repeat}
          onValueChange={value => setValue("repeat", value)}
        />
      </div>
      <div className="pdp-form-item last-item">
        <span className="pdp-form-item-title">{I18n.t("pdp.form.time_with_vicky.fields.ending.label")}</span>
        <RadioGroup
          slim
          items={[
            { label: I18n.t("pdp.form.time_with_vicky.fields.ending.options.manual"), value: "manual" },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.ending.options._on._on"),
              view: renderEndDateOption(),
              value: "on"
            },
            {
              label: I18n.t("pdp.form.time_with_vicky.fields.ending.options.after.after"),
              view: renderEndOccurencesOption(), 
              value: "after"
            },
          ]}
          initialValue={defaultValues.ending.type}
          onItemSelected={item => setValue("ending.type", item.value)}
        />
      </div>
      <div className="pdp-form-error">
        {error?.message}
      </div>
    </FormSection>
  );
}

export default TimeWithVicky;
